import Navbar from "@/components/Navbar";
import LogoBanner from "@/components/LogoBanner";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Products from "@/components/Products";
import VideoShowcase from "@/components/VideoShowcase";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloating from "@/components/WhatsAppFloating";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[var(--tt-cream)] min-h-screen">
      <LogoBanner />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Products />
      <VideoShowcase />
      <Contact />
      <Footer />
      <WhatsAppFloating />
    </div>
  );
}
